import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ 'pages/index/home/home.vue'),
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import(/* webpackChunkName: "mobile" */ 'pages/index/mobile/mobile.vue'),
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: () => import(/* webpackChunkName: "inventory" */ 'pages/index/inventory/inventory.vue'),
  },
  {
    path: '/staff',
    name: 'staff',
    component: () => import(/* webpackChunkName: "staff" */ 'pages/index/staff/staff.vue'),
  },
  {
    path: '/content/:menuId?/:submenuId?',
    name: 'content',
    component: () => import(/* webpackChunkName: "content" */ 'pages/index/content/index.vue'),
    meta: {
      // darkHeader: true,
    },
  },
  {
    path: '*',
    redirect: '/',
  },
];

const indexRouter = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

export default indexRouter;
